// extracted by mini-css-extract-plugin
export default {"ShopItemDocuments":"ShopItemDocuments_ShopItemDocuments__0Klxt"};